module.exports = __webpack_public_path__ + "img/hdyy_details_3.1b0d5c6f.png";